import {styled} from "styled-components";
import {Button, Card, Tag} from "antd";

export const StyledCard = styled<any>(Card)`
    border-radius: 10px;
    .ant-card-body {
        padding: 10px 8px;
    }

`;
export const StyledTag = styled(Tag)`
    background-color: #d7dbe5;
    font-size: .58rem !important;
    border-radius: 10px;
    padding: 0px 10px 0px 10px;

`;
export const StyledButton = styled(Button)`
    border-radius: 7px;
`;
